// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { DocumentoPartecipataDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class DocumentoPartecipataApiClient extends BaseCRUDApiClient<DocumentoPartecipataDto> {
  baseUrl = this.config.apiEndpoint + '/documento-partecipata';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
